import instance from "../axios/axios";

// Fetch all contact enquiries with pagination, search, and status filter
export const getContactEnquiries = async ({ page, limit, search, status }) => {
    try {
        const response = await instance.get(`/api/contact-enquire/contact-enquiries?page=${page}&limit=${limit}&search=${search}&status=${status}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};


// Update the status of an enquiry
export const updateEnquiryStatus = async (id, data) => {
    try {
        const response = await instance.put(`/api/contact-enquire/${id}/status`, data);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Delete an enquiry
export const deleteEnquiry = async (id) => {
    try {
        const response = await instance.delete(`/api/contact-enquire/contact-enquiries/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};